import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import PermissionError from './Error/PermissionError';
import config from '../config';

const AgencyRoute = ({ children, requiredPermission = true }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // Başlangıç durumu
    const [permissions, setPermissions] = useState(null); // Yetkileri saklamak için
    const userData = JSON.parse(localStorage.getItem('user_data')); // Kullanıcı verilerini al

    const checkTokenAndPermissions = async () => {
        if (userData && userData.token) {
            try {
                const response = await axios.post(
                    `${config.API_BASE_URL_V1}agency/check`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${userData.token}`,
                        },
                    }
                );

                if (response.status === 200) {

                    setIsAuthenticated(true); // Kullanıcı doğrulandı
                    setPermissions(response.data.data); // Yetkileri sakla
                    localStorage.setItem('agency_id', response.data.data.agency_id);
                    localStorage.setItem('is_agency_user', response.data.data.isAgencyUser);
                    localStorage.setItem('is_hotel_user', response.data.data.isHotelUser);
                }
            } catch (error) {
                console.error('Token veya yetki doğrulama hatası:', error.response?.data || error.message);
                setIsAuthenticated(false);
            }
        } else {
            setIsAuthenticated(false);
        }
    };

    useEffect(() => {
        checkTokenAndPermissions();
    }, []);

    if (isAuthenticated === null) {
        return (
            <div id="loader-wrapper">
                <div id="loader">
                    <span className="loader-line"></span>
                </div>
            </div>
        );
    }


    // Eğer doğrulanmış ancak gerekli yetkiye sahip değilse
    if(requiredPermission != null && requiredPermission == true)
    {
        return isAuthenticated ? children : <Navigate to="/login" />;
    }
    else
    {
        if (isAuthenticated && permissions && !permissions[requiredPermission]) {
            return <PermissionError />;
        }
    }
    

    // Giriş yapılmamışsa veya yetkisizse giriş sayfasına yönlendir
    return isAuthenticated ? children : <Navigate to="/login" />;
};

export default AgencyRoute;
